import { ClassTimestampsHelper } from '../ClassHelper';
import Account from '../account/Account';
import DynamicPrice from '../price/DynamicPrice';
import User from '../user/User';
import DateTZ from '../date/DateTZ';

class DiscountBase extends ClassTimestampsHelper {
  constructor({ type, title, account, cntActivations, startDate, endDate, discount, appliesTo, forGroups, users = [], status } = {}) {
    super(...arguments);
    this.type = type; // DiscountType
    this.title = title;
    this.account = this.ref(account, Account);
    this.cntActivations = cntActivations;
    this.startDate = this.obj(startDate, DateTZ);
    this.endDate = this.obj(endDate, DateTZ);
    this.discount = this.obj(discount, DynamicPrice);
    this.appliesTo = appliesTo; // AppliesTo
    this.forGroups = forGroups; // ForGroup
    this.users = this.array(users, User, true);
    this.status = status; // Status
  }

  isApplyTo({date}) {
    const granularity = 'day';
    const inclusive = '[]'; // By default - inlude both edges
    const dCheck = new DateTZ(date).dayjs;
    const dStart = this.startDate?.dayjs;
    const dEnd = this.endDate?.dayjs;
    const dAi = inclusive[0] === '(';
    const dBi = inclusive[1] === ')';

    return !!dCheck && (
        (
          (!dStart || (dAi ? dCheck.isAfter(dStart, granularity)  : !dCheck.isBefore(dStart, granularity))) &&
          (!dEnd   || (dBi ? dCheck.isBefore(dEnd, granularity)   : !dCheck.isAfter(dEnd, granularity)))
        )
      || (
          (!dStart || (dAi ? dCheck.isBefore(dStart, granularity) : !dCheck.isAfter(dStart, granularity))) &&
          (!dEnd   || (dBi ? dCheck.isAfter(dEnd, granularity)    : !dCheck.isBefore(dEnd, granularity)))
        )
    );
  }
}

export default DiscountBase;